import React from 'react'
import { ErrorPageBase } from './ErrorPageBase'

export const AccessDeniedPage = () => 
    <ErrorPageBase title='403 Forbidden' 
        descr = {<>
            Access to this page is denied.<br />
            Please ensure that you are signed in using an account with sufficient privileges.
        </>} />
